import React, { useContext } from 'react'
import Autocomplete from '../../../Shared/AutosuggestV2/Autosuggestv2'
import Select from 'react-select/creatable'
import styles from './InputFields.module.css'
import MultiSelectWithCheckbox from '../../../Shared/MultiSelectCheckbox/MultiSelectCheckbox'
import { UserApiContext } from '../../../UserDetailsContext/UserDetailsContext'

const AUTOCOMPLETE_STYLES = {
  container: (base) => ({
    ...base,
    height: '36px',
    maxHeight: '36px',
    margin: 0,
    width: '100%',
  }),
  control: (base) => ({
    ...base,
    minHeight: '36px',
    height: '36px',
    maxHeight: '36px',
    borderRadius: '6px',
    borderColor: '#cdd3de',
    fontSize: '12.5px',
    boxShadow: 'none',
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    margin: 0,
    '&:hover': {
      borderColor: '#393185',
    },
  }),
  placeholder: (base, state) => ({
    ...base,
    fontWeight: '400',
    color: '#8A93A0',
    fontSize: '12.5px',
    margin: 0,
    display: state.isFocused ? 'none' : 'block',
  }),
  input: (base) => ({ ...base, fontWeight: '400', fontSize: '12.5px', margin: 0, padding: 0 }),
  singleValue: (base) => ({ ...base, fontWeight: '500', fontSize: '12.5px', margin: 0 }),
  valueContainer: (base) => ({ ...base, padding: '0px 10px', height: '34px', display: 'flex', alignItems: 'center' }),
  indicatorsContainer: (base) => ({ ...base, height: '34px' }),

  /* ===== Width constrained to exact Origin/Destination input container ===== */
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    borderRadius: '8px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.05)',
    border: '1px solid #E2E8F0',
    padding: '4px',
    width: '100%',
    minWidth: '100%',
    maxWidth: '100%',
    left: 0,
    right: 0,
    boxSizing: 'border-box',
    overflow: 'hidden',
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: '260px',
    padding: '0',
    '&::-webkit-scrollbar': {
      width: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#CBD5E1',
      borderRadius: '3px',
    },
  }),
  option: (base, state) => ({
    ...base,
    fontSize: '12.5px',
    padding: '7px 10px',
    margin: '2px 0',
    borderRadius: '6px',
    cursor: 'pointer',
    backgroundColor: state.isSelected
      ? '#393185'
      : state.isFocused
        ? '#F0F4FF'
        : 'transparent',
    color: state.isSelected
      ? '#ffffff'
      : state.isFocused
        ? '#1E1B4B'
        : '#2B2B2B',
    fontWeight: state.isSelected || state.isFocused ? '600' : '400',
    transition: 'background-color 0.15s ease, color 0.15s ease',
  }),
  groupHeading: (base) => ({
    ...base,
    fontSize: '11px',
    fontWeight: '700',
    color: '#5C6672',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    padding: '6px 8px 3px 8px',
    margin: 0,
  }),
}

const TRUCK_SELECT_STYLES = {
  container: (base) => ({
    ...base,
    height: '36px',
    maxHeight: '36px',
    margin: 0,
    width: '100%',
  }),
  control: (base) => ({
    ...base,
    minHeight: '36px',
    height: '36px',
    maxHeight: '36px',
    borderRadius: '6px',
    borderColor: '#cdd3de',
    fontSize: '12.5px',
    boxShadow: 'none',
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    margin: 0,
    '&:hover': {
      borderColor: '#393185',
    },
  }),
  valueContainer: (base) => ({ ...base, padding: '0px 10px', height: '34px', display: 'flex', alignItems: 'center' }),
  indicatorsContainer: (base) => ({ ...base, height: '34px' }),
  dropdownIndicator: (base) => ({ ...base, padding: '0 6px' }),
  singleValue: (base) => ({ ...base, fontWeight: '500', fontSize: '12.5px', margin: 0 }),
  placeholder: (base, state) => ({
    ...base,
    fontWeight: '400',
    color: '#8A93A0',
    fontSize: '12.5px',
    margin: 0,
    display: state.isFocused ? 'none' : 'block',
  }),

  /* ===== Width constrained to exact Truck Type input container ===== */
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    borderRadius: '8px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.05)',
    border: '1px solid #E2E8F0',
    padding: '4px',
    width: '100%',
    minWidth: '100%',
    maxWidth: '100%',
    left: 0,
    right: 0,
    boxSizing: 'border-box',
    overflow: 'hidden',
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: '260px',
    padding: '0',
    '&::-webkit-scrollbar': {
      width: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#CBD5E1',
      borderRadius: '3px',
    },
  }),
  option: (base, state) => ({
    ...base,
    fontSize: '12.5px',
    padding: '7px 10px',
    margin: '2px 0',
    borderRadius: '6px',
    cursor: 'pointer',
    backgroundColor: state.isSelected
      ? '#393185'
      : state.isFocused
        ? '#F0F4FF'
        : 'transparent',
    color: state.isSelected
      ? '#ffffff'
      : state.isFocused
        ? '#1E1B4B'
        : '#2B2B2B',
    fontWeight: state.isSelected || state.isFocused ? '600' : '400',
    transition: 'background-color 0.15s ease, color 0.15s ease',
  }),
  groupHeading: (base) => ({
    ...base,
    fontSize: '11px',
    fontWeight: '700',
    color: '#5C6672',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    padding: '6px 8px 3px 8px',
    margin: 0,
  }),
}

const MULTISELECT_STYLES = {
  container: (base) => ({
    ...base,
    height: '36px',
    maxHeight: '36px',
    margin: 0,
    width: '100%',
  }),
  control: (base) => ({
    ...base,
    minHeight: '36px',
    height: '36px',
    maxHeight: '36px',
    borderRadius: '6px',
    borderColor: '#cdd3de',
    fontSize: '12.5px',
    boxShadow: 'none',
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    margin: 0,
    '&:hover': {
      borderColor: '#393185',
    },
  }),
  valueContainer: (base) => ({ ...base, padding: '0px 10px', height: '34px', display: 'flex', alignItems: 'center' }),
  indicatorsContainer: (base) => ({ ...base, height: '34px' }),
  dropdownIndicator: (base) => ({ ...base, padding: '0 6px' }),
  placeholder: (base, state) => ({
    ...base,
    fontWeight: '400',
    color: '#8A93A0',
    fontSize: '12.5px',
    margin: 0,
    display: state.isFocused ? 'none' : 'block',
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
    borderRadius: '8px',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12), 0 2px 6px rgba(0, 0, 0, 0.05)',
    border: '1px solid #E2E8F0',
    padding: '4px',
    width: '100%',
    minWidth: '100%',
    maxWidth: '100%',
    left: 0,
    right: 0,
    boxSizing: 'border-box',
    overflow: 'hidden',
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: '260px',
    padding: '0',
    '&::-webkit-scrollbar': {
      width: '5px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#CBD5E1',
      borderRadius: '3px',
    },
  }),
  option: (base, state) => ({
    ...base,
    fontSize: '12.5px',
    padding: '7px 10px',
    margin: '2px 0',
    borderRadius: '6px',
    cursor: 'pointer',
    backgroundColor: state.isSelected
      ? '#393185'
      : state.isFocused
        ? '#F0F4FF'
        : 'transparent',
    color: state.isSelected
      ? '#ffffff'
      : state.isFocused
        ? '#1E1B4B'
        : '#2B2B2B',
    fontWeight: state.isSelected || state.isFocused ? '600' : '400',
    transition: 'background-color 0.15s ease, color 0.15s ease',
  }),
}

const BLOCKED_KEYS = new Set(['-', 'e', 'E'])

const InputFields = ({
  inputorigin,
  setorigin,
  setinputorigin,
  inputdestination,
  setdestination,
  setinputdestination,
  TruckTypes,
  onChangeTruckTypes,
  selectedTrucks,
  addLanetoProcurement,
  settonnage,
  tonnage,
  capacity,
  setcapacity,
  selectedIndustry,
  setSelectedIndustry,
  materialCategories,
  isRestricted,
  renderTermsElement,
}) => {
  const { userDetails } = useContext(UserApiContext)
  const companyId = userDetails?.profile_company_id

  const handleWeightKeyDown = (e) => {
    if (BLOCKED_KEYS.has(e.key)) e.preventDefault()
  }

  const formatTruckLabel = ({ label, isMyTruck }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', overflow: 'hidden', width: '100%' }}>
      {isMyTruck && (
        <i
          className="fa fa-truck"
          style={{ color: '#393185', fontSize: '13px', flexShrink: 0 }}
        />
      )}
      <span
        style={{
          fontSize: '12.5px',
          fontWeight: '500',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
        title={label}
      >
        {label}
      </span>
    </div>
  )

  return (
    <div className={styles.newenq}>
      {/* ===== CARD HEADER: Subtitle Description on Left, Terms on Right ===== */}
      <div className={styles.cardHeader}>
        <div className={styles.lead}>
          <span className={styles.leadText}>
            LoRRI Spot is open marketplace for spot placement for company/spot business for empanelled transporters
          </span>
        </div>
        {renderTermsElement && (
          <div className={styles.termsTopRight}>
            {renderTermsElement}
          </div>
        )}
      </div>

      <form id="input_form" style={{ width: '100%' }} onSubmit={(e) => e.preventDefault()}>
        <div className={styles.negrid}>
          {/* ===== 1. ORIGIN ===== */}
          <div className={`${styles.nefield} ${styles.loc}`}>
            <span className={styles.lab}>
              Origin <span className={styles.req}>*</span>
            </span>
            <div className={styles.locwrap}>
              <Autocomplete
                value={
                  inputorigin
                    ? { label: inputorigin, value: inputorigin }
                    : null
                }
                placeholder="Origin"
                className="w-100"
                user_identifier={companyId}
                module_key="indents"
                onChange={(val) => setinputorigin(val)}
                onSelect={(obj) => {
                  setorigin(obj)
                  setinputorigin(obj?.location_name || obj?.value || '')
                }}
                customStyles={AUTOCOMPLETE_STYLES}
              />
            </div>
          </div>

          {/* ===== 2. DESTINATION ===== */}
          <div className={`${styles.nefield} ${styles.loc}`}>
            <span className={styles.lab}>
              Destination <span className={styles.req}>*</span>
            </span>
            <div className={styles.locwrap}>
              <Autocomplete
                value={
                  inputdestination
                    ? { label: inputdestination, value: inputdestination }
                    : null
                }
                placeholder="Destination"
                className="w-100"
                user_identifier={companyId}
                module_key="indents"
                onChange={(val) => setinputdestination(val)}
                onSelect={(obj) => {
                  setdestination(obj)
                  setinputdestination(obj?.location_name || obj?.value || '')
                }}
                customStyles={AUTOCOMPLETE_STYLES}
              />
            </div>
          </div>

          {/* ===== 3. TRUCK TYPE ===== */}
          <div className={`${styles.nefield} ${styles.tt}`}>
            <span className={styles.lab}>
              Truck Type <span className={styles.req}>*</span>
            </span>
            <Select
              options={TruckTypes}
              onChange={onChangeTruckTypes}
              value={selectedTrucks}
              placeholder="Select..."
              styles={TRUCK_SELECT_STYLES}
              formatOptionLabel={formatTruckLabel}
            />
          </div>

          {/* ===== 4. WEIGHT ===== */}
          <div className={`${styles.nefield} ${styles.wtf}`}>
            <span className={styles.lab}>Weight</span>
            <div className={styles.wt}>
              <input
                className={styles.wtInput}
                placeholder="WT"
                id="truckWeight"
                type="number"
                value={tonnage}
                onKeyDown={handleWeightKeyDown}
                onChange={(e) => settonnage(e.target.value)}
              />
              <span
                className={`${styles.u} ${capacity === 'MT' ? styles.uOn : ''}`}
                onClick={() => setcapacity('MT')}
              >
                MT
              </span>
              <span
                className={`${styles.u} ${capacity === 'KG' ? styles.uOn : ''}`}
                onClick={() => setcapacity('KG')}
              >
                KG
              </span>
            </div>
          </div>

          {/* ===== 5. PRODUCT TYPE ===== */}
          <div className={`${styles.nefield} ${styles.pt}`}>
            <span className={styles.lab}>Product Type</span>
            <MultiSelectWithCheckbox
              options={materialCategories}
              onChange={(e) => setSelectedIndustry(e)}
              value={selectedIndustry}
              customStyles={MULTISELECT_STYLES}
            />
          </div>

          {/* ===== 6. ADD BUTTON (+) ===== */}
          <button
            type="button"
            className={styles.neadd}
            disabled={isRestricted}
            style={{
              cursor: isRestricted ? 'not-allowed' : 'pointer',
              opacity: isRestricted ? 0.6 : 1,
            }}
            title="Add enquiry"
            onClick={addLanetoProcurement}
          >
            +
          </button>
        </div>
      </form>
    </div>
  )
}

export default InputFields